export default "__VITE_ASSET__DFcOcfZt__"